import { useMyProfile } from "@seabrookstudios/pitch2table";

export const useHasSlug = () => {
  const { data: profile } = useMyProfile();

  if (!profile) {
    return false;
  }
  if (!profile.slug) {
    return false;
  }
  if (profile.slug.trim().length === 0) {
    return false;
  }

  return true;
};
